<template>
  <AsyncPage
    :loader="useOnboardingLoader"
    :page-component="Onboarding"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useOnboardingLoader } from "./Onboarding.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const Onboarding = defineAsyncComponent(
  () => import("./Onboarding.vue"),
);
</script>
